import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const CookiePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-cream">
      <Header />
      <main>
        <section className="pt-32 pb-20">
          <div className="container mx-auto px-6">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-serif font-bold text-wood-dark mb-8">
                Çerez Politikası
              </h1>
              
              <div className="prose prose-lg max-w-none space-y-6 text-wood">
                <p className="text-sm text-wood/60">Son Güncelleme: 15 Ocak 2024</p>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">1. Çerez Nedir?</h2>
                  <p>
                    Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza veya ağ sunucusuna depolanan küçük metin dosyalarıdır. Web sitemizde çerez kullanılmasının başlıca amacı, kullanıcı deneyimini geliştirmek ve web sitesinin işlevselliğini artırmaktır.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">2. Çerez Türleri</h2>
                  
                  <h3 className="text-xl font-semibold text-wood-dark mt-6 mb-3">2.1. Zorunlu Çerezler</h3>
                  <p>
                    Web sitesinin düzgün çalışması için gerekli olan çerezlerdir. Bu çerezler olmadan web sitesi düzgün çalışmayacaktır. Örneğin, güvenlik çerezleri, oturum çerezleri gibi.
                  </p>

                  <h3 className="text-xl font-semibold text-wood-dark mt-6 mb-3">2.2. Performans Çerezleri</h3>
                  <p>
                    Web sitesinin performansını ölçmek ve iyileştirmek için kullanılan çerezlerdir. Hangi sayfaların en çok ziyaret edildiği, kullanıcıların sitede ne kadar zaman geçirdiği gibi bilgileri toplar.
                  </p>

                  <h3 className="text-xl font-semibold text-wood-dark mt-6 mb-3">2.3. İşlevsellik Çerezleri</h3>
                  <p>
                    Kullanıcı tercihlerini hatırlamak ve kişiselleştirilmiş bir deneyim sunmak için kullanılır. Örneğin, dil tercihi, bölge seçimi gibi.
                  </p>

                  <h3 className="text-xl font-semibold text-wood-dark mt-6 mb-3">2.4. Hedefleme/Reklam Çerezleri</h3>
                  <p>
                    Kullanıcıların ilgi alanlarına göre özelleştirilmiş reklamlar göstermek için kullanılır. Bu çerezler, kullanıcıların web sitesi ziyaretlerini takip eder.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">3. Web Sitemizde Kullanılan Çerezler</h2>
                  
                  <div className="overflow-x-auto mt-4">
                    <table className="min-w-full bg-white rounded-xl overflow-hidden">
                      <thead className="bg-wood text-white">
                        <tr>
                          <th className="px-6 py-3 text-left text-sm font-semibold">Çerez Adı</th>
                          <th className="px-6 py-3 text-left text-sm font-semibold">Türü</th>
                          <th className="px-6 py-3 text-left text-sm font-semibold">Süresi</th>
                          <th className="px-6 py-3 text-left text-sm font-semibold">Amacı</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-wood/10">
                        <tr>
                          <td className="px-6 py-4 text-sm">session_id</td>
                          <td className="px-6 py-4 text-sm">Zorunlu</td>
                          <td className="px-6 py-4 text-sm">Oturum</td>
                          <td className="px-6 py-4 text-sm">Kullanıcı oturumunu yönetmek</td>
                        </tr>
                        <tr>
                          <td className="px-6 py-4 text-sm">cookie_consent</td>
                          <td className="px-6 py-4 text-sm">Zorunlu</td>
                          <td className="px-6 py-4 text-sm">1 yıl</td>
                          <td className="px-6 py-4 text-sm">Çerez tercihlerini kaydetmek</td>
                        </tr>
                        <tr>
                          <td className="px-6 py-4 text-sm">_ga</td>
                          <td className="px-6 py-4 text-sm">Performans</td>
                          <td className="px-6 py-4 text-sm">2 yıl</td>
                          <td className="px-6 py-4 text-sm">Google Analytics - Ziyaretçi analizi</td>
                        </tr>
                        <tr>
                          <td className="px-6 py-4 text-sm">language</td>
                          <td className="px-6 py-4 text-sm">İşlevsellik</td>
                          <td className="px-6 py-4 text-sm">1 yıl</td>
                          <td className="px-6 py-4 text-sm">Dil tercihini hatırlamak</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">4. Çerezleri Nasıl Kontrol Edebilirsiniz?</h2>
                  <p>
                    Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkânına sahipsiniz. Tarayıcınızın ayarlarını kullanarak çerezleri engelleyebilir, silebilir veya çerezler konusunda uyarı alabilirsiniz.
                  </p>
                  
                  <h3 className="text-xl font-semibold text-wood-dark mt-6 mb-3">Popüler Tarayıcılarda Çerez Ayarları:</h3>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li><strong>Google Chrome:</strong> Ayarlar &gt; Gizlilik ve güvenlik &gt; Çerezler ve diğer site verileri</li>
                    <li><strong>Mozilla Firefox:</strong> Ayarlar &gt; Gizlilik ve Güvenlik &gt; Çerezler ve Site Verileri</li>
                    <li><strong>Safari:</strong> Tercihler &gt; Gizlilik &gt; Çerezler ve web sitesi verileri</li>
                    <li><strong>Microsoft Edge:</strong> Ayarlar &gt; Çerezler ve site izinleri &gt; Çerezleri yönet ve sil</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">5. Üçüncü Taraf Çerezler</h2>
                  <p>
                    Web sitemizde, hizmet sağlayıcılarımız tarafından yerleştirilen üçüncü taraf çerezler de bulunmaktadır. Bu çerezler, analiz, reklam ve sosyal medya entegrasyonu gibi amaçlarla kullanılmaktadır.
                  </p>
                  <ul className="list-disc pl-6 space-y-2 mt-4">
                    <li><strong>Google Analytics:</strong> Web sitesi trafiğini analiz etmek için</li>
                    <li><strong>Google Maps:</strong> Konum bilgilerini göstermek için</li>
                    <li><strong>Facebook Pixel:</strong> Reklam kampanyalarını optimize etmek için</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">6. Çerez Politikası Değişiklikleri</h2>
                  <p>
                    Bu Çerez Politikası, yasal düzenlemelerdeki değişiklikler veya web sitemizdeki güncellemeler nedeniyle zaman zaman güncellenebilir. Politikada yapılan önemli değişiklikler web sitemizde duyurulacaktır.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-serif font-bold text-wood-dark mt-8 mb-4">7. İletişim</h2>
                  <p>
                    Çerez Politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
                  </p>
                  <p className="mt-4">
                    <strong>E-posta:</strong> info@izmirtadilat.com<br />
                    <strong>Telefon:</strong> 0542 113 81 10<br />
                    <strong>Adres:</strong> Poligon Mahallesi 1620 Sokak No:12 Karabağlar / İzmir
                  </p>
                </section>

                <div className="mt-12 pt-8 border-t border-wood/20">
                  <Link
                    to="/"
                    className="inline-flex items-center text-wood hover:text-wood-dark font-medium transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-left-line mr-2"></i>
                    Anasayfaya Dön
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CookiePage;
